// extracted by mini-css-extract-plugin
export default {"Pointer":"allorders_Pointer__NmYJc","SummaryValue":"allorders_SummaryValue__8fFQP","ReportRange":"allorders_ReportRange__VUHvj"};